import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Container, Grid, useTheme, Box } from "@mui/material";
import Controls from "../components/FormsUI";
import { useAuth } from "../utility/auth";
import BankController from "../controller/BankController";
import ExceptionHandlerController from "../controller/ErrorLogsController";
import Load from "../components/FormsUI/Loader/index";
import MastersController from "../controller/MastersController";
import CustomizedSnackbars from "../components/Alert";
// import CountLoader from "../components/FormsUI/CountLoader";
import "../css/style.css";
import { tokens } from "../theme";

const INITIAL_FORM_STATE = {
  tenantId: "",
  bankCodeId: "",
  ifscCode: "",
  accountNumber: "",
  accountType: "",
  accountName: "",
  branch: "",
};

const FORM_VALIDATION = Yup.object().shape({
  bankCodeId: Yup.string().required("Bank name is required"),
  ifscCode: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("IFSC code is required")
    .matches("[A-Za-z]{4}0[A-Za-z0-9]{6}", "Incorrect IFSCCode format")
    .length(11, "Max length can be 11"),
  accountNumber: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Account number is required"),
  accountType: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Account type is required"),
  accountName: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .required("Account name is required")
    .max(100)
    .matches(/^[A-Za-z ]*$/, "only characters allowed "),
  branch: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches("[A-Za-z]", "only characters allowed ")
    .min(3, "Should be minimum 3 character")
    .max(100, "Should not exceed 100 characters"),
});

let bankName = [];
let accountType = [
  { value: "Current", label: "Current" },
  { value: "Saving", label: "Saving" },
];
const Bank = () => {
  const bankController = new BankController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const mastersController = new MastersController();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [bankId, setBankId] = useState("");
  const [loader, setLoader] = useState(true);
  // const [loader1, setLoader1] = useState(false);
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [bankValue, setBankValue] = useState(null);
  const [accountTypeValue, setAccountTypeValue] = useState(null);
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [ifscCode, setIfscCode] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    // setLoader1(true)
    let caughtError;
    try {
      //fetching bank masters for dropdown options
      const getBankMasters = () => {
        mastersController
          .GetMastersBank()
          .then((result) => {
            if (result?.status === 200) {
              setLoader(() => false);
              if (bankName?.length === 0)
                result?.data?.body?.map((item) => {
                  return bankName?.push({
                    label: item?.bankName,
                    value: item?.bankID,
                  });
                });
              GetBank();
              //fetching bank data
            } else {
              showAlert("error", "something went wrong kindly refresh");
              setLoader(() => false);
            }
          })
          .catch((error) => {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: "Bank page Get method" };
            exceptionHandlerController.HandleException(logError);
          });
      };
      getBankMasters();
      const GetBank = () => {
        bankController
          .Get(tenantId, token)
          .then((resultObj) => {
            setLoader(() => false);
            if (resultObj?.status === 200) {
              const responseData = resultObj?.data?.body;
              setIfscCode(() => responseData?.ifscCode);
              setBankId(responseData?.bankId);
              const bankLabel = bankName?.filter(
                (item) => item?.value === responseData?.bankCodeId
              )[0];
              setBankValue(bankLabel);
              const accountLabel = accountType?.filter(
                (item) => item?.value === responseData?.accountType
              )[0];
              setAccountTypeValue(accountLabel);
              setUpdatedValues(responseData);
            }
          })
          .catch((error) => {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: "Bank page Get method" };
            exceptionHandlerController.HandleException(logError);
          });
      };
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "bank details page Get method" };
      exceptionHandlerController.HandleException(logError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const submitValues = (dataValue) => {
    let caughtError;
    try {
      const details = auth?.decoder(sessionStorage?.getItem("user"));
      dataValue.tenantId = details?.data?.UserInfo?.userid;
      dataValue.branch = dataValue?.branch ? dataValue.branch : undefined;
      //based on bankId creating or updating records
      if (!bankId) {
        bankController
          .Create(dataValue, details?.token)
          .then((response) => {
            if (response?.data?.status === 201) {
              setBankId(response?.data?.body?.bankId);
              showAlert("success", response?.data?.message);
            } else {
              showAlert("error", response?.response?.data?.message);
            }
          })
          .catch(handleErrorSubmitValues);
      } else {
        dataValue.bankId = bankId;
        dataValue.accountNumber = String(dataValue.accountNumber);
        bankController
          .Update(dataValue, details?.token)
          .then((response) => {
            if (response?.data?.status === 200) {
              showAlert("success", response?.data.message);
            } else {
              showAlert("error", response?.response?.data?.message);
            }
          })
          .catch((error) => {
            showAlert("error", "Oops something went wrong. ");
          });
      }
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "Bank details page submit method" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const handleErrorSubmitValues = (error) => {
    let logData = {
      message: error?.message,
      stack: error?.stack,
    };
    let logError = {
      logData,
      module: "feeReceipt getMastersFeeFor method",
    };
    exceptionHandlerController.HandleException(logError);
  };
  if (loader) return <Load />;
  // if (loader1) return <CountLoader
  //   size={75}
  //   strokeWidth={5}
  //   duration={10000}
  //   count={10}
  // />
  return (
    <Box
      sx={{
        "& .formBg": {
          border: `1px solid ${colors.grey[900]}`,
          background: `${colors.primary[400]}`,
        },
        "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
        "& .MuiGrid-root.Mui-heading h2": {
          color: `${colors.primary[200]} !important`,
        },
      }}
    >
      <Grid container>
        <Grid className="breadcrumb-section">
          <Grid className="breadcrumb-container">
            <Grid className="Mui-li">
              <nav className="Mui-nav" aria-label="breadcrumb">
                <ol className="">
                  <li className="MuiBreadcrumbs-li">
                    <h6 className="breadsub">Home</h6>
                  </li>
                  <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                    /
                  </li>
                  <li className="MuiBreadcrumbs-li">
                    <h6>Bank</h6>
                  </li>
                </ol>
              </nav>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className="formBg">
          <Container maxWidth="md" className="formClwidth">
            <div>
              <Formik
                enableReinitialize
                initialValues={{ ...(updatedValues || INITIAL_FORM_STATE) }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values) => submitValues(values)}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Controls.AutoComplete
                          id="bankCodeId"
                          name="bankCodeId"
                          options={bankName}
                          label={
                            <span>
                              Bank Name <span className="asterisk">*</span>
                            </span>
                          }
                          value={bankValue}
                          onChange={(event, value) => {
                            if (value?.value) {
                              setFieldValue("bankCodeId", value?.value);
                              setBankValue(value);
                            }
                          }}
                          autoFocus
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="ifscCode"
                          label={
                            <span>
                              IFSC Code <span className="asterisk">*</span>
                            </span>
                          }
                          type="string"
                          value={ifscCode}
                          inputProps={{ maxLength: 11 }}
                          placeholder="AAAA0999999"
                          onChange={(event) => {
                            const { value } = event?.target;
                            setIfscCode(value?.toUpperCase());
                            setFieldValue("ifscCode", value?.toUpperCase());
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="accountNumber"
                          label={
                            <span>
                              Account Number <span className="asterisk">*</span>
                            </span>
                          }
                          type="string"
                          inputProps={{ minLength: 9, maxLength: 17 }}
                          placeholder="9999999999"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.AutoComplete
                          id="accountType"
                          name="accountType"
                          options={accountType}
                          label={
                            <span>
                              Account Type <span className="asterisk">*</span>
                            </span>
                          }
                          value={accountTypeValue}
                          onChange={(event, value) => {
                            if (value?.value) {
                              setFieldValue("accountType", value?.value);
                              setAccountTypeValue(value);
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="accountName"
                          label={
                            <span>
                              Account Name <span className="asterisk">*</span>
                            </span>
                          }
                          inputProps={{ maxLength: 30 }}
                          type="string"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Controls.Textfield
                          name="branch"
                          label="Branch name"
                          inputProps={{ maxLength: 30 }}
                          type="string"
                        />
                      </Grid>
                      <Grid item xs={4} md={2} className="marginAuto">
                        <Controls.Button>Submit</Controls.Button>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
              {alert.counter > 0 && (
                <CustomizedSnackbars
                  status={alert.counter}
                  msg={alert.msg}
                  type={alert.type}
                />
              )}
            </div>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Bank;
